var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunnelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_367_4568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0176 5.19406L16.012 5.20039L11.2497 10.2854V14.187C11.25 14.3726 11.2044 14.5553 11.1169 14.719C11.0294 14.8827 10.9028 15.0221 10.7484 15.125L8.49841 16.6255C8.32885 16.7384 8.13181 16.8032 7.92831 16.8129C7.72481 16.8226 7.5225 16.7769 7.34297 16.6806C7.16343 16.5843 7.01342 16.441 6.90894 16.2661C6.80446 16.0912 6.74943 15.8912 6.74974 15.6875V10.2854L1.98747 5.20039L1.98185 5.19406C1.83542 5.03292 1.7389 4.83274 1.704 4.61782C1.6691 4.4029 1.69732 4.18247 1.78523 3.98327C1.87314 3.78407 2.01697 3.61466 2.19927 3.4956C2.38157 3.37653 2.5945 3.31293 2.81224 3.3125H15.1872C15.4052 3.31252 15.6184 3.37583 15.801 3.49474C15.9836 3.61364 16.1278 3.78303 16.2159 3.98231C16.3041 4.18159 16.3325 4.40219 16.2977 4.6173C16.2628 4.83241 16.1663 5.03278 16.0197 5.19406H16.0176Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_4568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelIcon);
export default __webpack_public_path__ + "static/media/funnel-icon.add50961.svg";
export { ForwardRef as ReactComponent };